module.exports = __webpack_public_path__ + "assets/img/btn-back-d3a47b3c.png";